var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 123,
    viewBox: "0 0 127 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 10
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M122.4 69.8C122.4 84 116.6 96.8 107.3 106C98.2 115.1 85.6 120.6 71.7 120.6C57.9 120.6 45.3 115 36.1 106C26.8 96.8 21 84 21 69.8C21 41.7 43.7 19 71.7 19C99.7 19 122.4 41.8 122.4 69.8Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M117.7 36.4998C119.964 36.4998 121.8 34.6642 121.8 32.3998C121.8 30.1354 119.964 28.2998 117.7 28.2998C115.436 28.2998 113.6 30.1354 113.6 32.3998C113.6 34.6642 115.436 36.4998 117.7 36.4998Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M123.7 20.4999C125.246 20.4999 126.5 19.2463 126.5 17.6999C126.5 16.1535 125.246 14.8999 123.7 14.8999C122.154 14.8999 120.9 16.1535 120.9 17.6999C120.9 19.2463 122.154 20.4999 123.7 20.4999Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.3 36.3998C23.8464 36.3998 25.1 35.1462 25.1 33.5998C25.1 32.0534 23.8464 30.7998 22.3 30.7998C20.7536 30.7998 19.5 32.0534 19.5 33.5998C19.5 35.1462 20.7536 36.3998 22.3 36.3998Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.2 90.4C8.07188 90.4 10.4 88.0719 10.4 85.2C10.4 82.3281 8.07188 80 5.2 80C2.32812 80 0 82.3281 0 85.2C0 88.0719 2.32812 90.4 5.2 90.4Z",
    fill: "#EAEEF9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    filter: "url(#filter0_d_604_17202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.529 46.5109L108.329 110.911C108.329 113.111 106.529 114.811 104.329 114.811H41.5293C39.3293 114.811 37.5293 113.011 37.5293 110.911V28.1109C37.5293 25.9109 39.3293 24.2109 41.5293 24.2109H87.0293L107.529 46.5109Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M70.2291 37.7108H48.1291C47.4291 37.7108 46.8291 37.1108 46.8291 36.4108C46.8291 35.7108 47.4291 35.1108 48.1291 35.1108H70.2291C70.9291 35.1108 71.5291 35.7108 71.5291 36.4108C71.5291 37.1108 70.9291 37.7108 70.2291 37.7108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M59.7291 44.911H48.1291C47.4291 44.911 46.8291 44.311 46.8291 43.611C46.8291 42.911 47.4291 42.311 48.1291 42.311H59.6291C60.3291 42.311 60.9291 42.911 60.9291 43.611C60.9291 44.311 60.3291 44.911 59.7291 44.911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M87.0293 24.2109V42.0109C87.0293 44.5109 89.2293 46.5109 91.7293 46.5109H107.529",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 14",
    d: "M56.7625 37.4758L61.5141 20.7158L81.0307 22.9639L74.2168 33.8862L79.4947 38.103L68.1319 62.9566L68.765 43.7151L56.7625 37.4758Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 15",
    d: "M60.9799 18.2657L57.1982 12.5732",
    stroke: "#A2ABBE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 16",
    d: "M71.065 15.4195L71.5093 1",
    stroke: "#A2ABBE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 17",
    d: "M80.1069 18.4L86.1436 5.29736",
    stroke: "#A2ABBE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M59.5713 90.3788C59.1513 90.3788 58.8152 90.2108 58.4792 89.9588C57.8911 89.3707 57.8911 88.3625 58.4792 87.7744C62.3437 83.9939 67.4685 81.8936 72.9293 81.8936C78.3902 81.8936 83.515 83.9939 87.3795 87.7744C87.9676 88.3625 87.9676 89.3707 87.3795 89.9588C86.7915 90.5469 85.7833 90.5469 85.1952 89.9588C81.9187 86.6823 77.55 84.918 72.9293 84.918C68.3086 84.918 63.94 86.6823 60.6635 89.9588C60.3274 90.2108 59.9914 90.3788 59.5713 90.3788Z",
    fill: "#F35F5D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M64.8641 67.8634L66.8804 65.8471C67.4685 65.259 67.4685 64.2508 66.8804 63.6627C66.2923 63.0747 65.2842 63.0747 64.6961 63.6627L62.6798 65.6791L60.6635 63.6627C60.0754 63.0747 59.0672 63.0747 58.4792 63.6627C57.8911 64.2508 57.8911 65.259 58.4792 65.8471L60.4955 67.8634L58.4792 69.8797C57.8911 70.4678 57.8911 71.4759 58.4792 72.064C58.8152 72.4001 59.1513 72.4841 59.5713 72.4841C59.9914 72.4841 60.3274 72.3161 60.6635 72.064L62.6798 70.0477L64.6961 72.064C65.0322 72.4001 65.3682 72.4841 65.7883 72.4841C66.2083 72.4841 66.5444 72.3161 66.8804 72.064C67.4685 71.4759 67.4685 70.4678 66.8804 69.8797L64.8641 67.8634Z",
    fill: "#F35F5D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M85.2792 67.8634L87.2955 65.8471C87.8836 65.259 87.8836 64.2508 87.2955 63.6627C86.7074 63.0747 85.6992 63.0747 85.1111 63.6627L83.0948 65.6791L81.0785 63.6627C80.4904 63.0747 79.4823 63.0747 78.8942 63.6627C78.3061 64.2508 78.3061 65.259 78.8942 65.8471L80.9105 67.8634L78.8942 69.8797C78.3061 70.4678 78.3061 71.4759 78.8942 72.064C79.2302 72.4001 79.5663 72.4841 79.9864 72.4841C80.4064 72.4841 80.7425 72.3161 81.0785 72.064L83.0948 70.0477L85.1111 72.064C85.4472 72.4001 85.7832 72.4841 86.2033 72.4841C86.6234 72.4841 86.9594 72.3161 87.2955 72.064C87.8836 71.4759 87.8836 70.4678 87.2955 69.8797L85.2792 67.8634Z",
    fill: "#F35F5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_604_17202",
    x: 33.5293,
    y: 24.2109,
    width: 78.8,
    height: 98.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_604_17202"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_604_17202",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedIcon);
export default __webpack_public_path__ + "static/media/rejectedIcon.a7805d783ce3b228388f86f7d18a3e22.svg";
export { ForwardRef as ReactComponent };